export default __webpack_public_path__ + "static/media/apply-whitelist.54ee5949.png";